<template>
  <div>
    <div class="row">
      <div class="col-sm-2">
        <div>
          <img :src="'/images/bannerlayout.png'" alt="" />
        </div>
      </div>
      <div class="col-sm-10">
        <div>
          <h2 style="font-weight: 600; margin-bottom: 0.5rem !important">
            Gallery Images
          </h2>
          <small style="font-size: 80% !important"
            >Choose an image that will be displayed at the top of your
            page</small
          >
        </div>
      </div>
    </div>
   <form ref="form" data-url="/admin/company/profile/gallery/store" class="mt-4">
      <div class="form-row">
        <div class="form-group col-12">
          <app-input
            type="dropzone"
            v-model="dropzone_files"
            :required="true"
          />
        </div>
      </div>
      <div class="mt-2" v-if="btnShow == true">
        <app-load-more
                  :preloader="preloader"
                  :label="$t('save')"
                  type="submit"
                  class-name="btn btn-primary text-center"
                  @submit="submit"
                />
      </div>
      <div class="form-group row align-items-center mt-3">
          <div
            class="col-lg-2 col-md-2 col-sm-12"
            v-for="(val, index) in gallery"
            :key="index"
          >
            <div class="form-group">
              <img
                :src="val.image"
                alt="uploaded file"
                class="img-thumbnail"
              />
            </div>
            <span
              v-if="btnShow == true"
              class="dz-remove"
              style="cursor: pointer"
              @click.prevent="deletefile(val.id, index)"
              >Remove file</span
            >
          </div>
        </div>
    </form>
  </div>
</template>
<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import {
  axiosDelete,
} from "../../../../Helpers/AxiosHelper";
import { DELETE_GALLERY_IMAGE } from "../../../../Config/ApiUrl";
export default {
  mixins: [FormMixin],
  data() {
    return {
      dropzone_files: [],
      btnShow: true,
      gallery: this.$store.state.userCompanyProfile.dataProfile.company.gallery,
    };
  },
computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
  methods: {
    deletefile(id , index) {
      this.gallery.splice(index, 1);
      axiosDelete(DELETE_GALLERY_IMAGE + "/" + id)
        .then((res) => {
          

          this.$toastr.s(res.data.message);
        })
        .catch((error) => {
          this.$toastr.e(error);
        })
        .finally(() => {
          this.getTask();
        });
    },
    beforeSubmit(){
        this.preloader = true;
      },
    submit() {
      
      let formData = new FormData();

      if (this.dropzone_files.length) {
        this.dropzone_files.forEach((dropzone_file) =>
          formData.append(`dropzone_file[]`, dropzone_file)
        );
      }
      this.save(formData);
    },

    afterSuccess(res) {
      this.$toastr.s(res.data.message);
      },
      // afterFinalResponse() {
      //   this.preloader = false;
      // },
      afterError(res) {
        this.$toastr.e(res.data.message);
      },
  },
  mounted() {
    var profileType = url.substring(url.lastIndexOf("/") + 1);
      if(profileType != 'my-profile') {
        this.btnShow = false;
      } 
  }
};
</script>
